import ComponentNavBar from 'ageas-react-component-nav-bar'

import { AnimalsSecured } from '../../Types/AnimalStore'
import { AnimalTabGeneralData } from './AnimalTabGeneralData'
import { Cell, Row } from './style'

type Props = {
  animal: AnimalsSecured
}

export function ExpandedRow({ animal }: Props) {
  return (
    <Row>
      <Cell colSpan="5" noPadding>
        <ComponentNavBar
          key={`componentNavBarRisk-${animal.id}-${animal.name}`}
          id={`componentNavBarRisk-${animal.id}-${animal.name}`}
          tabs={['']}
          noPaddingBottom
          table={{
            rows: [
              {
                columns: [
                  {
                    componentCol: [
                      <AnimalTabGeneralData
                        key={`animalTabGeneralData-${animal.id}-${animal.name}`}
                        animal={animal}
                      />,
                    ],
                  },
                ],
              },
            ],
          }}
          colorTheme="blue"
          activeTab={0} // default
          buttonNext={false}
          buttonLabel="Next"
        />
      </Cell>
    </Row>
  )
}
